<template>
    <div class="drop-down">
        <div class="drop-down__head" :class="{'drop-down__head_active': open}" @click="open = !open">
            <h5><slot name="header" /></h5>
            <div class="def-plus">
                <div></div>
                <div></div>
            </div>
        </div>
        <SlideUpDown :modelValue="open">
            <div class="drop-down__block">
                <slot />
            </div>
        </SlideUpDown>
    </div>
</template>

<script>
    export default {
        name: 'drop-down',
        selector: '.drop-down',
        props: {
            active: Boolean
        },
        data() {
            return {
                open: this.active ? this.active : false
            }
        }
    }
</script>

<style lang="scss">
    .drop-down{
        border-bottom: 1px solid #DFDFDF;
        &__head{
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 64px;
            font-weight: 500;
            letter-spacing: 0.08em;
            text-transform: uppercase;
            color: #191918;
            &_active{
                .def-plus{
                    & > *:nth-child(2) {
                        transform: rotate(180deg);
                    }
                }
            }
            &:hover{
                cursor: pointer;
            }
            h5{
                font-size: rem(14);
                @include point-md{
                    font-size: rem(16);
                }
            }
        }
        &__block{
            padding-bottom: 18px;
        }
    }
</style>